export const RECEIVE_PRIMARY_HEADER_PROMO_BANNER = 'RECEIVE_PRIMARY_HEADER_PROMO_BANNER';
export const RECEIVE_GENERIC_PROMO_BANNER = 'RECEIVE_GENERIC_PROMO_BANNER';

export function receivePrimaryHeaderPromoBanner(response) {
    return {
        type: RECEIVE_PRIMARY_HEADER_PROMO_BANNER,
        payload: {
            promoData: response
        }
    };
}

export function receiveGenericPromoBanner(response, key) {
    return {
        type: RECEIVE_GENERIC_PROMO_BANNER,
        payload: {
            promoData: response,
            promoKey: key
        }
    };
}
